import { useHistory } from "react-router-dom";
import { links } from "../configs/web-links-configs";

function useNavigation() {
  let history = useHistory();

  function navigate(key, params) {
    let path = links[key];
    if (!path) {
      throw new Error("Key doesn't exsit.");
    }

    let qs = [];
    if (params) {
      let { productID, order_id, ...restParams } = params;
      if (productID) {
        path = `${path}/${productID}`;
      }
      if (order_id) {
        path = `${path}/${order_id}`;
      }

      let paramsKeys = Object.keys(restParams);
      if (paramsKeys.length > 0) {
        for (let key of paramsKeys) {
          let value = restParams[key];

          if (typeof value === "object") {
            value = JSON.stringify(value);
          }

          qs.push(`${key}=${value}`);
        }
      }
    }

    if (qs.length > 0) {
      path = `${path}?${qs.join("&")}`;
    }
    history.push(path);
  }

  return {
    jumpAndNavigate({ navigateTo, navigateParams }) {
      navigate(navigateTo, navigateParams);
    },
    navigate,
    goBack: history.goBack,
    canGoBack() {
      return history.action !== "POP";
    },
  };
}

export default useNavigation;
